// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1n-yd","disabled":"FileBtn_disabled__2Ut8I","warn":"FileBtn_warn__1cuny","fade":"FileBtn_fade__3dAIu"};